/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ontem",
        "-2": "anteontem",
        "0": "hoje",
        "1": "amanhã",
        "2": "depois de amanhã",
        "future": {
          "one": "dentro de {0} dia",
          "other": "dentro de {0} dias"
        },
        "past": {
          "one": "há {0} dia",
          "other": "há {0} dias"
        }
      },
      "day-narrow": {
        "-1": "ontem",
        "-2": "anteontem",
        "0": "hoje",
        "1": "amanhã",
        "2": "depois de amanhã",
        "future": {
          "one": "+{0} dia",
          "other": "+{0} dias"
        },
        "past": {
          "one": "-{0} dia",
          "other": "-{0} dias"
        }
      },
      "day-short": {
        "-1": "ontem",
        "-2": "anteontem",
        "0": "hoje",
        "1": "amanhã",
        "2": "depois de amanhã",
        "future": {
          "one": "dentro de {0} dia",
          "other": "dentro de {0} dias"
        },
        "past": {
          "one": "há {0} dia",
          "other": "há {0} dias"
        }
      },
      "hour": {
        "0": "esta hora",
        "future": {
          "one": "dentro de {0} hora",
          "other": "dentro de {0} horas"
        },
        "past": {
          "one": "há {0} hora",
          "other": "há {0} horas"
        }
      },
      "hour-narrow": {
        "0": "esta hora",
        "future": {
          "one": "+{0} h",
          "other": "+{0} h"
        },
        "past": {
          "one": "-{0} h",
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "esta hora",
        "future": {
          "one": "dentro de {0} h",
          "other": "dentro de {0} h"
        },
        "past": {
          "one": "há {0} h",
          "other": "há {0} h"
        }
      },
      "minute": {
        "0": "este minuto",
        "future": {
          "one": "dentro de {0} minuto",
          "other": "dentro de {0} minutos"
        },
        "past": {
          "one": "há {0} minuto",
          "other": "há {0} minutos"
        }
      },
      "minute-narrow": {
        "0": "este minuto",
        "future": {
          "one": "+{0} min",
          "other": "+{0} min"
        },
        "past": {
          "one": "-{0} min",
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "este minuto",
        "future": {
          "one": "dentro de {0} min",
          "other": "dentro de {0} min"
        },
        "past": {
          "one": "há {0} min",
          "other": "há {0} min"
        }
      },
      "month": {
        "-1": "mês passado",
        "0": "este mês",
        "1": "próximo mês",
        "future": {
          "one": "dentro de {0} mês",
          "other": "dentro de {0} meses"
        },
        "past": {
          "one": "há {0} mês",
          "other": "há {0} meses"
        }
      },
      "month-narrow": {
        "-1": "mês passado",
        "0": "este mês",
        "1": "próximo mês",
        "future": {
          "one": "+{0} mês",
          "other": "+{0} meses"
        },
        "past": {
          "one": "-{0} mês",
          "other": "-{0} meses"
        }
      },
      "month-short": {
        "-1": "mês passado",
        "0": "este mês",
        "1": "próximo mês",
        "future": {
          "one": "dentro de {0} mês",
          "other": "dentro de {0} meses"
        },
        "past": {
          "one": "há {0} mês",
          "other": "há {0} meses"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "trimestre passado",
        "0": "este trimestre",
        "1": "próximo trimestre",
        "future": {
          "one": "dentro de {0} trimestre",
          "other": "dentro de {0} trimestres"
        },
        "past": {
          "one": "há {0} trimestre",
          "other": "há {0} trimestres"
        }
      },
      "quarter-narrow": {
        "-1": "trim. passado",
        "0": "este trim.",
        "1": "próximo trim.",
        "future": {
          "one": "+{0} trim.",
          "other": "+{0} trim."
        },
        "past": {
          "one": "-{0} trim.",
          "other": "-{0} trim."
        }
      },
      "quarter-short": {
        "-1": "trim. passado",
        "0": "este trim.",
        "1": "próximo trim.",
        "future": {
          "one": "dentro de {0} trim.",
          "other": "dentro de {0} trim."
        },
        "past": {
          "one": "há {0} trim.",
          "other": "há {0} trim."
        }
      },
      "second": {
        "0": "agora",
        "future": {
          "one": "dentro de {0} segundo",
          "other": "dentro de {0} segundos"
        },
        "past": {
          "one": "há {0} segundo",
          "other": "há {0} segundos"
        }
      },
      "second-narrow": {
        "0": "agora",
        "future": {
          "one": "+{0} s",
          "other": "+{0} s"
        },
        "past": {
          "one": "-{0} s",
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "agora",
        "future": {
          "one": "dentro de {0} s",
          "other": "dentro de {0} s"
        },
        "past": {
          "one": "há {0} s",
          "other": "há {0} s"
        }
      },
      "week": {
        "-1": "semana passada",
        "0": "esta semana",
        "1": "próxima semana",
        "future": {
          "one": "dentro de {0} semana",
          "other": "dentro de {0} semanas"
        },
        "past": {
          "one": "há {0} semana",
          "other": "há {0} semanas"
        }
      },
      "week-narrow": {
        "-1": "semana passada",
        "0": "esta semana",
        "1": "próxima semana",
        "future": {
          "one": "+{0} sem.",
          "other": "+{0} sem."
        },
        "past": {
          "one": "-{0} sem.",
          "other": "-{0} sem."
        }
      },
      "week-short": {
        "-1": "semana passada",
        "0": "esta semana",
        "1": "próxima semana",
        "future": {
          "one": "dentro de {0} sem.",
          "other": "dentro de {0} sem."
        },
        "past": {
          "one": "há {0} sem.",
          "other": "há {0} sem."
        }
      },
      "year": {
        "-1": "ano passado",
        "0": "este ano",
        "1": "próximo ano",
        "future": {
          "one": "dentro de {0} ano",
          "other": "dentro de {0} anos"
        },
        "past": {
          "one": "há {0} ano",
          "other": "há {0} anos"
        }
      },
      "year-narrow": {
        "-1": "ano passado",
        "0": "este ano",
        "1": "próximo ano",
        "future": {
          "one": "+{0} ano",
          "other": "+{0} anos"
        },
        "past": {
          "one": "-{0} ano",
          "other": "-{0} anos"
        }
      },
      "year-short": {
        "-1": "ano passado",
        "0": "este ano",
        "1": "próximo ano",
        "future": {
          "one": "dentro de {0} ano",
          "other": "dentro de {0} anos"
        },
        "past": {
          "one": "há {0} ano",
          "other": "há {0} anos"
        }
      }
    },
    "locale": "pt-PT"
  });
}